import { AxiosResponse } from 'axios';
import internalAPI from '../../services/internalAPI';
import { AppDispatch } from '../configureStore';
import { UserMatch, UserMatchAction } from '../reducers/userMatchesReducer';
import signOutAction from './signOutAction';
import { TOGGLE_USER_MESSAGES, UPDATE_USER_MATCHES, USER_MATCH_STATUS } from './types';

import { addBookmark } from '../features/bookmark/addBookmark';
import {
  GET_USER_MATCHES,
  SELECT_USER_MATCH,
  TOGGLE_ALL_USER_MATCHES,
  TOGGLE_EDIT_USER_MATCH_INBOX,
  TOGGLE_USER_MATCH_INBOX
} from './types';

export const getUserMatchesAction = () => async (dispatch: AppDispatch) => {
  const response: AxiosResponse = await internalAPI(true)
    .get('/api/matches')
    .catch((e) => {
      if (e.status == 401) {
        dispatch(signOutAction());
      }
      return e;
    });

  if (response.data) {
    // adding extra fields to the matchObject to facilitate the match selection for deletion and mark as read
    const modifiedMatches: UserMatch[] = response.data.map((match: UserMatch) => ({ ...match, selected: false }));

    return dispatch({
      type: GET_USER_MATCHES,
      payload: {
        matches: modifiedMatches
      }
    });
  }
  return false;
};

export const updateUserMatchesAction =
  (match: UserMatch, action: UserMatchAction, status?: boolean) => async (dispatch: AppDispatch) => {
    const modifiedMatch: UserMatch = { ...match };
    const propertyKey = action.toLowerCase() as keyof UserMatch;

    // Handle modifying properties based on the action
    if (action === UserMatchAction.Seen || action === UserMatchAction.Saved || action === UserMatchAction.Dismissed) {
      modifiedMatch[propertyKey] = status ?? !modifiedMatch[propertyKey];
    }
    // If the usermatch had been saved previously, do not update again
    if (action == UserMatchAction.Saved && match.saved === true) {
      return;
    }

    const response: AxiosResponse = await internalAPI(true)
      .put('/api/matches', {
        match: modifiedMatch,
        action: action
      })
      .catch((e) => {
        if (e.status == 401) {
          dispatch(signOutAction());
        }
        return e;
      });

    if (response.status) {
      if (action == UserMatchAction.Saved) {
        if (modifiedMatch.saved) {
          dispatch(addBookmark({ entityUuid: modifiedMatch.contentId }));
        }
      }
      return dispatch({
        type: UPDATE_USER_MATCHES,
        payload: {
          match: modifiedMatch,
          action: action
        }
      });
    } else {
      return false;
    }
  };

export const selectMatchAction = (matchId: string, status: boolean) => async (dispatch: AppDispatch) => {
  dispatch({
    type: SELECT_USER_MATCH,
    payload: { matchId, status }
  });
};

export const toggleAllMatchesAction = (status: boolean) => async (dispatch: AppDispatch) => {
  dispatch({
    type: TOGGLE_ALL_USER_MATCHES,
    payload: { status }
  });
};

export const showUserMessages = (status: boolean) => async (dispatch: AppDispatch) => {
  dispatch({
    type: TOGGLE_USER_MESSAGES,
    payload: { status }
  });
};

export const showMatchInbox = (status: boolean) => async (dispatch: AppDispatch) => {
  dispatch({
    type: TOGGLE_USER_MATCH_INBOX,
    payload: { status }
  });
};

export const showMatchInboxSelection = (status: boolean) => async (dispatch: AppDispatch) => {
  dispatch({
    type: TOGGLE_EDIT_USER_MATCH_INBOX,
    payload: { status }
  });
};

export const updateUserMatchStatus = (status: boolean) => async (dispatch: AppDispatch) => {
  dispatch({
    type: USER_MATCH_STATUS,
    payload: { status }
  });
};
